<div class="tab-content match-summary live-timeline">
    @for (val of actions; track $index) {
    <div
        class="tab-pane show active"
        id="tab-match-summary-1-content"
        role="tabpanel"
        aria-labelledby="tab-match-summary-1"
    >
        @if (!isUnknown) {
        <h6
            class="text-center text-uppercase match-summary__head dropdown-toggle"
            data-toggle="collapse"
            [attr.href]="'#collapseAction' + val[0]"
            role="button"
            aria-expanded="false"
            [attr.aria-controls]="'collapseAction' + val[0]"
        >
            {{ 'web.' + sportName + '_' + val[0] | lowercase | translate }}
        </h6>
        }
        <div class="collapse show" [attr.id]="'collapseAction' + val[0]">
            @for (action of val[1]; track $index; let isLastMain = $last) {
            <div [@newLine] class="row no-gutters border-top py-1 px-1 small">
                @if (isTypeUnknown(action.type)) {
                <div class="col-12 font-weight-bold text-center">
                    <div class="row">
                        <div class="col-12 d-flex align-self-center live-timeline__data">
                            <div class="text-center">
                                @if (action.image) {
                                <img [src]="action.image + '?color=' + color" height="12" />
                                } &nbsp;&nbsp;
                                <strong>{{ action.text }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                } @if (!isTypeUnknown(action.type)) {

                <div class="col-4 d-flex justify-content-start">
                    @if (action.competitor == 'home') {
                    <div class="text-center d-flex flex-column flex-sm-row px-1 align-items-stretch">
                        @if (action.match_clock || action.match_time) {
                        <div>
                            <span>{{ action.match_clock || action.match_time }}</span>
                        </div>
                        }
                        <div class="pl-sm-1">
                            @if (action.image) {
                            <img [src]="action.image + '?color=' + color" height="12" />
                            }
                        </div>

                        @if (action.suspension_minutes && action.suspensionPlayers.length === 0) {

                        <div class="app-no-wrap">
                            &nbsp; <strong class="suspension-minute">{{ action.suspension_minutes }}</strong
                            >&nbsp;
                        </div>

                        }
                    </div>

                    <div class="d-flex flex-column live-timeline__data app-word-nowrap">
                        <div class="d-flex flex-column live-timeline__data pr-sm-1 app-word-nowrap --small2">
                            {{ 'web.timeline_american-football_type_' + action.type + '_short' | translate }}
                        </div>
                        @for (player of action.mainPlayers; track $index; let isFirst = $first) {
                        <div>
                            @if (!player.id) {
                            <span>
                                {{ player.name }}
                            </span>
                            } @if (player.id) {
                            <a
                                [routerLink]="['/page/sport/player', sportName + '-' + sportId, player.id]"
                                class="text-reset"
                            >
                                {{ player.name }}</a
                            >
                            }
                            <div class="--small">
                                ({{ 'web.american_football_player_type_' + player.type | translate }})
                            </div>
                        </div>
                        } @for (player of action.suspensionPlayers; track $index) {
                        <div class="app-no-wrap">
                            @if (!player.id) {
                            <span class="text-bold">
                                {{ player.name }}
                            </span>
                            } @if (player.id) {
                            <a
                                [routerLink]="['/page/sport/player', sportName + '-' + sportId, player.id]"
                                class="text-reset text-bold"
                            >
                                {{ player.name }}</a
                            >
                            } @if (action.suspension_minutes) {
                            <strong class="suspension-minute">{{ action.suspension_minutes }} </strong>
                            }
                        </div>
                        } @for ( player of action.assistsPlayers; track $index; let isLast = $last; let isFirst =
                        $first) {
                        <div>
                            @if (!player.id) {
                            <span>{{ player.name }}</span>
                            } @if (player.id) {
                            <a
                                [routerLink]="['/page/sport/player', sportName + '-' + sportId, player.id]"
                                class="text-reset"
                            >
                                {{ player.name }}</a
                            >
                            }
                            <div class="--small">
                                ({{ 'web.american_football_player_type_' + player.type | translate }})
                            </div>
                        </div>
                        }
                        <!-- Fouled players-->
                        @for (player of action.fouledPlayers; track $index; let isLast = $last) {
                        <div>
                            <span>
                                {{ 'web.player_who_' + player.type | translate }} <br />({{ player.name }})@if (!isLast)
                                { , }
                            </span>
                        </div>
                        }
                        <!-- Substitution players-->
                        @if (action.substitutionPlayers?.in && action.substitutionPlayers?.in.length > 0) {
                        <div>
                            @for (player of action.substitutionPlayers.in; track $index) {
                            <span class="text-bold"> {{ player.name }} </span>
                            }
                        </div>
                        } @if ( action.substitutionPlayers?.out && action.substitutionPlayers?.out.length > 0 ) { @for
                        (player of action.substitutionPlayers.out; track $index) {
                        <div>
                            <span> {{ player.name }}</span>
                        </div>
                        } } @if (action.red_balls_left) {
                        <div>
                            <span class="serve serve--snooker-timeline ml-0">{{ action.red_balls_left }}</span>
                            <span class="red_balls_left">
                                {{ action.red_balls_left }} {{ 'web.red_balls_left' | translate }}
                            </span>
                        </div>
                        } @if (isTypeText(action.type)) {
                        <div class="order-8">
                            <span class="text-less-emph">
                                {{ 'web.' + sportName + '_' + action.type | translate }}
                                @if (action.suspension_reason) { -
                                {{ 'web.suspension_' + action.suspension_reason | lowercase | translate }}
                                }
                            </span>
                        </div>
                        } @if (action.zone && action.method !== 'penalty') {
                        <div class="order-8">
                            <span class="text-less-emph">
                                <svg class="icon icon--lg d-none d-lg-inline">
                                    <use href="#icon-net" />
                                </svg>
                                {{ 'web.' + sportName + '_' + action.zone | translate }}
                                @if (action.shot_type) { ({{ 'web.' + sportName + '_' + action.shot_type | translate }})
                                }
                            </span>
                        </div>
                        }
                        <div class="order-7">
                            @if (isHandball(sportName) && action.method === 'penalty') {
                            <span class="text-less-emph">
                                {{ 'web.' + sportName + '_penalty' | translate }}
                            </span>
                            }
                        </div>
                    </div>
                    } @else { &nbsp; }
                </div>
                <div class="col-4 font-weight-bold text-center">
                    <div class="row">
                        @if (action.substitutionPlayers?.out.length === 0) {
                        <div class="col-3 d-flex align-self-center">
                            @if (action.homeScoreDiff > 1) {
                            <div>
                                <strong class="emph-text-node">+{{ action.homeScoreDiff }}</strong>
                            </div>
                            } &nbsp;
                        </div>
                        }
                        <div class="app-no-wrap col" [class.col-6]="action.substitutionPlayers?.out.length === 0">
                            @if ( (action.home_score !== null && action.away_score !== null) || action.frame_score) {
                            <span class="font-weight-normal">
                                @if (action.frame_score) {
                                <span
                                    class="font-1-1x"
                                    [class.text-bold]="action.competitor == 'home'"
                                    title="{{ 'web.snooker_frame_score' | translate }}"
                                    >{{ action.frameScoreHome }}</span
                                >
                                :
                                <span
                                    class="font-1-1x"
                                    [class.text-bold]="action.competitor == 'away'"
                                    title="{{ 'web.snooker_frame_score' | translate }}"
                                    >{{ action.frameScoreAway }}</span
                                >
                                @if (action.break) {
                                <div title="{{ 'web.snooker_break' | translate }}">{{ action.break }}</div>
                                } } @else {
                                <span
                                    class="font-1-2x"
                                    [class.emph-text-node]="action.competitor == 'home'"
                                    [class.text-bold]="action.competitor == 'home'"
                                    >{{ action.home_score }}</span
                                >
                                :
                                <span
                                    class="font-1-2x"
                                    [class.emph-text-node]="action.competitor == 'away'"
                                    [class.text-bold]="action.competitor == 'away'"
                                    >{{ action.away_score }}</span
                                >
                                }
                            </span>
                            } @else { &nbsp;
                            <!-- <span>
                                  {{ 'web.' + sportName + '.' + action.type | translate }}
                                </span> -->
                            <!-- Substition players-->
                            @if ( action.substitutionPlayers?.out.length > 0 && action.substitutionPlayers?.in.length >
                            0 && !action.competitor ) { &nbsp;@if (action.image) {
                            <img [src]="action.image + '?color=' + color" height="13" />
                            }&nbsp;
                            <ng-container>
                                <strong>
                                    @for ( player of action.substitutionPlayers.in; track $index) {

                                    <span class="text-bold">
                                        {{ player.name }}
                                    </span>

                                    }
                                </strong>
                            </ng-container>
                            <ng-container>
                                @for ( player of action.substitutionPlayers.out; track $index) {

                                <div>
                                    {{ player.name }}
                                </div>

                                }
                            </ng-container>

                            } }
                            <ng-template #text>
                                &nbsp;
                                <!-- <span>
                                {{ 'web.' + sportName + '.' + action.type | translate }}
                              </span> -->
                                <!-- Substition players-->
                                @if ( action.substitutionPlayers?.out.length > 0 &&
                                action.substitutionPlayers?.in.length > 0 && !action.competitor ) { &nbsp;@if
                                (action.image) {
                                <img [src]="action.image + '?color=' + color" height="13" />
                                }&nbsp;
                                <ng-container>
                                    <strong>
                                        @for ( player of action.substitutionPlayers.in; track $index) {

                                        <span class="text-bold">
                                            {{ player.name }}
                                        </span>

                                        }
                                    </strong>
                                </ng-container>
                                <ng-container>
                                    @for ( player of action.substitutionPlayers.out; track $index) {

                                    <div>
                                        {{ player.name }}
                                    </div>

                                    }
                                </ng-container>

                                }
                            </ng-template>
                        </div>
                        @if (action.substitutionPlayers?.out.length === 0) {
                        <div class="col-3 d-flex align-self-center">
                            &nbsp; @if (action.awayScoreDiff > 1) {

                            <div>
                                <strong class="emph-text-node">+{{ action.awayScoreDiff }}</strong>
                            </div>

                            }
                        </div>
                        }
                    </div>
                </div>
                <div class="col-4 text-right d-flex justify-content-end">
                    @if (action.competitor == 'away') {
                    <div class="d-flex flex-column live-timeline__data app-word-nowrap">
                        @for (player of action.mainPlayers; track $index; let isFirst = $first) {
                        <div class="order-4">
                            @if (!player.id) {
                            <span>
                                {{ player.name }}
                            </span>
                            } @if (player.id) {
                            <a
                                [routerLink]="['/page/sport/player', sportName + '-' + sportId, player.id]"
                                class="text-reset"
                            >
                                {{ player.name }}</a
                            >
                            }
                            <div class="--small">
                                ({{ 'web.american_football_player_type_' + player.type | translate }})
                            </div>
                        </div>
                        } @for (player of action.suspensionPlayers; track $index) {
                        <div class="app-no-wrap">
                            @if (action.suspension_minutes) {
                            <strong class="suspension-minute">{{ action.suspension_minutes }} </strong>
                            } @if (!player.id) {
                            <span class="text-bold">
                                {{ player.name }}
                            </span>
                            } @if (player.id) {
                            <a
                                [routerLink]="['/page/sport/player', sportName + '-' + sportId, player.id]"
                                class="text-reset text-bold"
                            >
                                {{ player.name }}</a
                            >
                            }
                        </div>
                        } @for ( player of action.assistsPlayers; track $index; let isLast = $last; let isFirst =
                        $first) {
                        <div class="order-5">
                            @if (!player.id) {
                            <span>{{ player.name }}</span>
                            } @if (player.id) {
                            <a
                                [routerLink]="['/page/sport/player', sportName + '-' + sportId, player.id]"
                                class="text-reset"
                            >
                                {{ player.name }}</a
                            >
                            }
                            <div class="--small">
                                ({{ 'web.american_football_player_type_' + player.type | translate }})
                            </div>
                        </div>
                        }
                        <!-- Fouled players-->
                        @for (player of action.fouledPlayers; track $index; let isLast = $last) {
                        <div>
                            <span>
                                {{ 'web.player_who_' + player.type | translate }} <br />({{ player.name }})@if (!isLast)
                                { , }
                            </span>
                        </div>
                        }
                        <!-- Substition players-->
                        @if (action.substitutionPlayers?.in && action.substitutionPlayers?.in.length > 0) { @for (player
                        of action.substitutionPlayers.in; track $index) {
                        <div>
                            <span class="text-bold">
                                {{ player.name }}
                            </span>
                        </div>
                        } } @if ( action.substitutionPlayers?.out && action.substitutionPlayers?.out.length > 0 ) { @for
                        (player of action.substitutionPlayers.out; track $index) {
                        <div>
                            <span>
                                {{ player.name }}
                            </span>
                        </div>
                        } } @if (action.red_balls_left) {
                        <div>
                            <span class="red_balls_left">
                                {{ 'web.red_balls_left' | translate }} {{ action.red_balls_left }}
                            </span>
                            <span class="serve serve--snooker-timeline mr-0">{{ action.red_balls_left }}</span>
                        </div>
                        } @if (isTypeText(action.type)) {
                        <div class="order-8">
                            <span class="text-less-emph">
                                {{ 'web.' + sportName + '_' + action.type | translate }}
                                @if (action.suspension_reason) { -
                                {{ 'web.suspension_' + action.suspension_reason | lowercase | translate }}
                                }
                            </span>
                        </div>
                        } @if (action.zone && action.method !== 'penalty') {
                        <div class="order-8">
                            <span class="text-less-emph">
                                {{ 'web.' + sportName + '_' + action.zone | translate }}
                                @if (action.shot_type) { ({{ 'web.' + sportName + '_' + action.shot_type | translate }})
                                }
                                <svg class="icon icon--lg d-none d-lg-inline">
                                    <use href="#icon-net" />
                                </svg>
                            </span>
                        </div>
                        }
                        <div class="d-flex flex-column live-timeline__data pl-sm-1 app-word-nowrap --small2">
                            {{ 'web.timeline_american-football_type_' + action.type + '_short' | translate }}
                        </div>
                    </div>
                    <div class="text-center d-flex flex-column flex-sm-row px-1 align-items-stretch">
                        @if (action.match_clock || action.match_time) {
                        <div class="order-1">
                            <span>{{ action.match_clock || action.match_time }}</span>
                        </div>
                        } @if (action.suspension_minutes && action.suspensionPlayers.length === 0) {
                        <div class="app-no-wrap">
                            &nbsp; <strong class="suspension-minute">{{ action.suspension_minutes }}</strong
                            >&nbsp;
                        </div>
                        }
                        <div class="pr-sm-1">
                            @if (action.image) {
                            <img [src]="action.image + '?color=' + color" class="order-0" height="12" />
                            }
                        </div>
                    </div>

                    } @else { &nbsp; }
                </div>

                }
            </div>
            }
        </div>
    </div>
    }
</div>
